import Button from 'react-bootstrap/Button';
import './Button.scss';

const CustomButton = ({ children, onClick, type = 'button', className = '', variant = 'primary', ...props }) => {
  return (
    <Button
      type={type}
      className={`av-btn ${className}`}
      variant={variant}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
